import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/components/login/login.component';
import { SharedModule } from './shared/shared.module';
import { DesyAngularModule } from 'desy-angular';
import { AuthModule, OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from 'src/environments/environment';
import { APP_INITIALIZER } from '@angular/core';
import { AuthInterceptor } from './auth/auth.interceptor';
import { UserService } from './services/user.service';
import { CancelHttpOnRouteChangeInterceptor } from './shared/interceptor/cancel-http.interceptor';

export function initializeAuth(oidc: OidcSecurityService, userService: UserService) {
  return () =>
    oidc.checkAuth().toPromise().then(async (loginResponse) => {
      if (loginResponse?.isAuthenticated) { 
        const userData = loginResponse.userData;
        const name = userData?.name || userData?.preferred_username || userData?.email || null;
        const document = userData?.id || null;

        // Seteamos nombre y documento
        userService.setUserName(name);
        userService.setUserDocument(document);

        // Si hay documento, traemos los roles desde el backend
        if (document) {
          try {
            const user = await userService.getUserByDocument(document).toPromise();
            if (user?.roles) {
              userService.setUserRoles(user.roles);
            }
          } catch (error) {
          }
        }
      }
    });
  }

@NgModule({
  declarations: [AppComponent, LoginComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    DesyAngularModule,
    SharedModule,
    AuthModule.forRoot({
      config: {
        authority: environment.oidc.authority,
        redirectUrl: environment.urlLogin + '/auth-callback',
        postLogoutRedirectUri: environment.urlLogin,
        clientId: environment.oidc.clientId,
        scope: environment.oidc.scope,
        responseType: environment.oidc.responseType,
        silentRenew: true,
        useRefreshToken: true,
        autoUserInfo: false,
        renewTimeBeforeTokenExpiresInSeconds: 300, // 5 minutos
        disableIatOffsetValidation: true,
      },
    }),
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CancelHttpOnRouteChangeInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [OidcSecurityService, UserService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}